import _ from "underts";
const relevantHoraire = (allHoraires, date) => {
    "use strict";
    return _.last(allHoraires
        .filter((horaire) => horaire.date <= date)
        .sort((h1, h2) => h1.date.getTime() - h2.date.getTime()));
};
export default relevantHoraire;
//# sourceMappingURL=relevantHoraire.js.map